/* tslint:disable */
/* eslint-disable */
/**
 * Agora Livestock API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0.0 (v2)
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { APIException } from '../model';
// @ts-ignore
import { BookingConfirmation } from '../model';
// @ts-ignore
import { PaginatedBookingConfirmationList } from '../model';
/**
 * OrganisationBookingDataRequestIncomingApi - axios parameter creator
 * @export
 */
export const OrganisationBookingDataRequestIncomingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the incoming Data Requests associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestIncomingList: async (bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestIncomingList', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestIncomingList', 'buyerOrgId', buyerOrgId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/incoming`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['page_size'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single incoming Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} incomingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestIncomingRetrieve: async (bookingId: string, buyerOrgId: string, incomingRequestId: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'bookingId' is not null or undefined
            assertParamExists('orgBookingDataRequestIncomingRetrieve', 'bookingId', bookingId)
            // verify required parameter 'buyerOrgId' is not null or undefined
            assertParamExists('orgBookingDataRequestIncomingRetrieve', 'buyerOrgId', buyerOrgId)
            // verify required parameter 'incomingRequestId' is not null or undefined
            assertParamExists('orgBookingDataRequestIncomingRetrieve', 'incomingRequestId', incomingRequestId)
            const localVarPath = `/v2/org/{buyer_org_id}/booking/{booking_id}/data-request/incoming/{incoming_request_id}`
                .replace(`{${"booking_id"}}`, encodeURIComponent(String(bookingId)))
                .replace(`{${"buyer_org_id"}}`, encodeURIComponent(String(buyerOrgId)))
                .replace(`{${"incoming_request_id"}}`, encodeURIComponent(String(incomingRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKey required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganisationBookingDataRequestIncomingApi - functional programming interface
 * @export
 */
export const OrganisationBookingDataRequestIncomingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OrganisationBookingDataRequestIncomingApiAxiosParamCreator(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the incoming Data Requests associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestIncomingList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaginatedBookingConfirmationList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestIncomingList(bookingId, buyerOrgId, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single incoming Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} incomingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async orgBookingDataRequestIncomingRetrieve(bookingId: string, buyerOrgId: string, incomingRequestId: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BookingConfirmation>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.orgBookingDataRequestIncomingRetrieve(bookingId, buyerOrgId, incomingRequestId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OrganisationBookingDataRequestIncomingApi - factory interface
 * @export
 */
export const OrganisationBookingDataRequestIncomingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OrganisationBookingDataRequestIncomingApiFp(configuration)
    return {
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Retrieve a list of all the incoming Data Requests associated with the Booking
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {number} [page] A page number within the paginated result set.
         * @param {number} [pageSize] Number of results to return per page.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestIncomingList(bookingId: string, buyerOrgId: string, page?: number, pageSize?: number, options?: any): AxiosPromise<PaginatedBookingConfirmationList> {
            return localVarFp.orgBookingDataRequestIncomingList(bookingId, buyerOrgId, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Allow external IDs to be used for generic API views.
         * @summary Get the details of a single incoming Data Request
         * @param {string} bookingId 
         * @param {string} buyerOrgId 
         * @param {string} incomingRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        orgBookingDataRequestIncomingRetrieve(bookingId: string, buyerOrgId: string, incomingRequestId: string, options?: any): AxiosPromise<BookingConfirmation> {
            return localVarFp.orgBookingDataRequestIncomingRetrieve(bookingId, buyerOrgId, incomingRequestId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for orgBookingDataRequestIncomingList operation in OrganisationBookingDataRequestIncomingApi.
 * @export
 * @interface OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingListRequest
 */
export interface OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingListRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingList
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingList
     */
    readonly buyerOrgId: string

    /**
     * A page number within the paginated result set.
     * @type {number}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingList
     */
    readonly page?: number

    /**
     * Number of results to return per page.
     * @type {number}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingList
     */
    readonly pageSize?: number
}

/**
 * Request parameters for orgBookingDataRequestIncomingRetrieve operation in OrganisationBookingDataRequestIncomingApi.
 * @export
 * @interface OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieveRequest
 */
export interface OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieveRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieve
     */
    readonly bookingId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieve
     */
    readonly buyerOrgId: string

    /**
     * 
     * @type {string}
     * @memberof OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieve
     */
    readonly incomingRequestId: string
}

/**
 * OrganisationBookingDataRequestIncomingApi - object-oriented interface
 * @export
 * @class OrganisationBookingDataRequestIncomingApi
 * @extends {BaseAPI}
 */
export class OrganisationBookingDataRequestIncomingApi extends BaseAPI {
    /**
     * Allow external IDs to be used for generic API views.
     * @summary Retrieve a list of all the incoming Data Requests associated with the Booking
     * @param {OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingListRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestIncomingApi
     */
    public orgBookingDataRequestIncomingList(requestParameters: OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingListRequest, options?: any) {
        return OrganisationBookingDataRequestIncomingApiFp(this.configuration).orgBookingDataRequestIncomingList(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Allow external IDs to be used for generic API views.
     * @summary Get the details of a single incoming Data Request
     * @param {OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganisationBookingDataRequestIncomingApi
     */
    public orgBookingDataRequestIncomingRetrieve(requestParameters: OrganisationBookingDataRequestIncomingApiOrgBookingDataRequestIncomingRetrieveRequest, options?: any) {
        return OrganisationBookingDataRequestIncomingApiFp(this.configuration).orgBookingDataRequestIncomingRetrieve(requestParameters.bookingId, requestParameters.buyerOrgId, requestParameters.incomingRequestId, options).then((request) => request(this.axios, this.basePath));
    }
}
